import { NgTemplateOutlet } from '@angular/common'
import { Component, Input } from '@angular/core'
import { Data } from '@angular/router'
import { featureFlag } from '@ftr/ui-feature-flags'
import { AppLayoutComponent } from '../app-layout'
import { AppLayoutLegacyComponent } from '../app-layout-legacy'
import { AppLayoutNoSideNavComponent } from '../app-layout-no-sidenav'

@Component({
  selector: 'ftr-app-display',
  templateUrl: './app-display.component.html',
  imports: [AppLayoutComponent, AppLayoutLegacyComponent, AppLayoutNoSideNavComponent, NgTemplateOutlet],
})
export class AppDisplayComponent {
  @Input() showNavigationRedesign: boolean
  @Input() hasSideNavigation: boolean
  @Input() routeData: Data | undefined

  isPublicNavigationEnabled = featureFlag('public-navigation')
}
